/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import { QueryClient, QueryClientProvider } from 'react-query';

import { App } from 'id-components/App';
import { loadConfig, getConfig } from 'id-utils/config';

const queryClient = new QueryClient();

import './index.scss';

void (async () => {
  await loadConfig();

  if (getConfig().sentryDSN) {
    Sentry.init({
      dsn: getConfig().sentryDSN,
      environment: getConfig().nodeEnv,
    });
  }

  ReactDOM.render(
    <Router>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Router>,
    document.getElementById('root'),
  );
})();
